/**
 * Centralized post-login landing route by role.
 *
 * Phase 3 routing rule:
 *   - primary_owner / owner → /command-center
 *   - agent                 → /admin-dashboard
 *   - user (seller)         → /dashboard
 *   - unknown / null        → /dashboard (safe default)
 */
export type PostLoginRole =
  | "primary_owner"
  | "owner"
  | "agent"
  | "user"
  | string
  | null
  | undefined;

export function getPostLoginRedirect(role: PostLoginRole): string {
  if (role === "primary_owner" || role === "owner") return "/command-center";
  if (role === "agent") return "/admin-dashboard";
  return "/dashboard";
}
